export interface PaletteProps {
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook?: string;
  /** Defines an array of fill items for the palette. Accepts solid colors, gradients or images. */
  fill?: React.ReactNode[];
}
